export default "__VITE_ASSET__c296e521__"